import dayjs from "dayjs";
import { AmountSuperScript } from "components/design/AmountSuperScript";
import { TaxFiling } from "store/apis/filing";
import { Accordion } from "components/DesignSystem/Accordion/Accordion";
import { FilePreviewTag } from "components/FilePreviewTag/FilePreviewTag";

export const FilingDetails = ({ data }: { data: TaxFiling }) => {
  const filedCopy = data?.filing_summary;

  return (
    <Accordion.Root
      className="t-w-full t-space-y-4"
      type="multiple"
      defaultValue={["DETAILS"]}
    >
      <Accordion.Item
        value="DETAILS"
        className="t-border t-border-neutral-10 t-rounded-lg t-w-full"
      >
        <Accordion.Trigger>
          <p className="t-text-subtext t-text-text-100 t-m-0">Filing details</p>{" "}
        </Accordion.Trigger>
        <Accordion.Content>
          <div className="t-py-4 t-pt-2 t-bg-surface t-flex t-flex-col t-gap-4">
            <div className="t-flex t-flex-wrap t-justify-between">
              <div>
                <p className="t-text-body-sm t-text-text-30  t-mb-1">Period</p>
                <p className="t-text-subtext t-text-text-100 t-m-0">
                  {dayjs(data?.filing_period_start_date).format("MMM")} -{" "}
                  {dayjs(data?.filing_period_end_date).format("MMM YYYY")}{" "}
                </p>
              </div>
              <div>
                <p className="t-text-body-sm t-text-text-30 t-mb-1">
                  No. of transactions
                </p>
                <p className="t-text-subtext t-text-text-100 t-m-0">
                  {data?.invoice_count}
                </p>
              </div>
              <div>
                <p className="t-text-body-sm t-text-text-30 t-mb-1">
                  Total sales
                </p>
                <p className="t-text-subtext t-text-text-100 t-m-0">
                  <AmountSuperScript amount={data?.total_sales} />
                </p>
              </div>
              <div>
                <p className="t-text-body-sm t-text-text-30 t-mb-1">
                  Total tax collected
                </p>
                <p className="t-text-subtext t-text-text-100 t-m-0">
                  <AmountSuperScript amount={data?.total_tax_collected} />
                </p>
              </div>
            </div>
            {filedCopy?.uuid && filedCopy?.name && filedCopy?.file_type && (
              <div>
                <p className="t-text-body-sm t-text-text-30 t-mb-1.5">
                  Filed copy
                </p>
                <FilePreviewTag
                  block
                  size="small"
                  className="t-px-3 t-py-2"
                  file={{
                    uuid: filedCopy.uuid,
                    name: filedCopy.name,
                    file_type: filedCopy.file_type,
                    is_previewable: Boolean(filedCopy.is_previewable),
                  }}
                />
              </div>
            )}
          </div>
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
};
